import React, {
    useMemo
} from "react";
import {
    Link
} from "react-router-dom";
import PropTypes from "prop-types";

function EventDetailLink({ children, href, to, tintColor, buttonTextColor, size }) {
    if ((href && to) || (!href && !to)) {
        console.error(
            "EventDetailLink: pass either 'href' or 'to', but not both."
        );
    }
    const style = useMemo(() => {
        return {
            backgroundColor: tintColor ?? "#fae33d",
            borderColor: tintColor ?? "#fae33d",
            color: buttonTextColor ?? "black",
            textDecorationLine: "none",
        };
    }, [tintColor, buttonTextColor]);
    const className = useMemo(() => {
        const classNames = ["btn", "btn-primary"];
        if (size === "lg") {
            classNames.push("btn-lg");
        }
        if (size === "sm") {
            classNames.push("btn-sm");
        }
        return classNames.join(" ");
    }, [size]);
    if (to) {
        return (
            <Link
                className={ className }
                to={ to }
                style={ style }
            >
                { children }
            </Link>
        );
    }
    return (
        <a
            className={ className }
            href={ href }
            target="_blank"
            rel="noreferrer noopener"
            style={ style }
        >
            { children }
        </a>
    );
}

EventDetailLink.propTypes = {
    children: PropTypes.node.isRequired,
    href: PropTypes.string,
    to: PropTypes.string,
    tintColor: PropTypes.string,
    buttonTextColor: PropTypes.string,
    size: PropTypes.oneOf(["sm", "md", "lg"]),
};

export default React.memo(EventDetailLink);
